import { Instance, types } from 'mobx-state-tree';
import { Artefact } from '../Artefact/Artefact';
import moment from 'moment';
import { yakofficeFirebaseConfig } from '@yakoffice/yakoffice-firebase';

export const Build = types.model(
    'Build',
    {
        id: types.identifier,
        commitSha: '',
        createdAt: '',
        isPublic: false,
        isSharedWithUser: false,
        releaseNotes: types.maybeNull(types.string),
        triggeredBy: '',
        triggeredByUsername: '',
        type: '',
        artefacts: types.array(Artefact)
    })
    .views(self => ({

        readableCreateAt() {

            const formattedCreatedAt = moment(self.createdAt).format('DD/MM/YY HH:mm');

            const friendly = () => {

                const today = moment(new Date()).format('DD/MM/YY');

                const yesterday = () => {

                    const date = new Date();

                    return moment(date.setDate(date.getDate() - 1)).format('DD/MM/YY');
                };

                const comparisonDate = moment(self.createdAt).format('DD/MM/YY');
                const justTheTime = moment(self.createdAt).format('HH:mm');

                if (today === comparisonDate)
                    return `Today ${justTheTime}`;

                if (yesterday() === comparisonDate)
                    return `Yesterday ${justTheTime}`;

                else return formattedCreatedAt;
            };

            return friendly();
        },

        androidArtefacts() {
            return self.artefacts.slice().filter(artefact => artefact.platform === 'android');
        },

        iosArtefacts() {
            return self.artefacts.slice().filter(artefact => artefact.platform === 'ios');
        },

        allArtefacts() {
            return self.artefacts.slice();
        },

        readableTriggeredBy() {

            const regex = /Snapshot dependency; .+?;.+\/ ?(.+?)(?:'|,|$)/;

            const nameRef = self.triggeredBy.match(regex);

            if (nameRef)
                return nameRef[1];
            else
                return self.triggeredBy;
        }
    }))
    .actions(self => ({

        getFirestoreLink: (projectId: string) => {

            // Todo: we can do this better with the api and just return it as a property on the dto.

            const REACT_APP_FIREBASE_CONFIG = process.env.REACT_APP_FIREBASE_CONFIG || 'development';

            const firebaseProject = REACT_APP_FIREBASE_CONFIG === 'production'
                ? yakofficeFirebaseConfig.prd.projectId
                : yakofficeFirebaseConfig.dev.projectId;

            return `https://console.firebase.google.com/project/${firebaseProject}/firestore/databases/-default-/data/features/builds/projects/${projectId}/builds/${self.id}`;
        },

        getPermalink: (projectId: string) => {

            const hostName = window.location.hostname;
            return `https://${hostName}/projects/${projectId}/builds/${self.id}`;
        }
    }));

export interface IBuild extends Instance<typeof Build> {
}
